import { makeAutoObservable } from 'mobx';

const CLOSE_COUNT_STORAGE_KEY = 'monthlyPlansWidgetCloseCount';
const MAX_CLOSE_COUNT = 3;

const readCloseCount = (): number => {
  try {
    const raw = localStorage.getItem(CLOSE_COUNT_STORAGE_KEY);
    const parsed = raw ? parseInt(raw, 10) : 0;
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
  } catch {
    return 0;
  }
};

const writeCloseCount = (value: number): void => {
  localStorage.setItem(CLOSE_COUNT_STORAGE_KEY, String(value));
};

export class MonthlyPlansStore {
  profit: string = '';
  revenue: string = '';

  isClosed: boolean = false;

  closeCount: number = readCloseCount();

  constructor() {
    makeAutoObservable(this);
  }

  get isHiddenPermanently(): boolean {
    return this.closeCount >= MAX_CLOSE_COUNT;
  }

  get isVisible(): boolean {
    return !this.isClosed && !this.isHiddenPermanently;
  }

  setProfit(value: string) {
    this.profit = value;
  }

  setRevenue(value: string) {
    this.revenue = value;
  }

  getFormData() {
    return {
      profit: +this.profit,
      revenue: +this.revenue,
    };
  }

  resetForm() {
    this.profit = '';
    this.revenue = '';
  }

  closeWidget() {
    if (this.isClosed) return;

    this.isClosed = true;
    this.closeCount += 1;
    writeCloseCount(this.closeCount);
  }
}

export const monthlyPlansStore = new MonthlyPlansStore();
